import React from 'react';
import { useLazyQuery, useQuery } from '@apollo/client';

import { GET_ALERTS_PAGE } from '../gqlSchemes/alertsPage';

function useGetAlertsPage(page, perPage, queryFilter, skip = false) {
  const [total, setTotal] = React.useState(null);

  const { data, loading, refetch, networkStatus, error } = useQuery(GET_ALERTS_PAGE, {
    fetchPolicy: 'no-cache',
    skip,
    variables: {
      page,
      perPage,
      filter: queryFilter,
    },
    onCompleted: () => {
      if (total === null)
        setTotal(data?.alert?.alertsPage?.pageInfo?.totalItems);
    },
    onError: (err) => {
      console.log('error: ', err);
    },
  });

  const [getLazyQueryAlerts] = useLazyQuery(GET_ALERTS_PAGE);

  return {
    alerts: data?.alert?.alertsPage?.items,
    loading,
    pageInfo: data?.alert?.alertsPage?.pageInfo,
    total,
    refetch,
    getLazyQueryAlerts,
    error,
  };
}

export default useGetAlertsPage;
